import React, { FC, useState } from 'react'
import MobileHeader from './MobileHeader/MobileHeader'
import DesktopHeader from './DesktopHeader/DesktopHeader'
import { HeaderProvider, MobileHeaderConfig } from './HeaderContext'
import { NavigationLinks } from './NavigationLinks'
import CartUrgencyBar from 'components/CartUrgencyBar'
import styles from './Header.module.scss'
import { constructorAbTestInPrintsLinks, transformNavLinks } from './helpers'
import { NavigationLinksArray } from './types'
import { useSelector } from 'react-redux'
import { getSharedIsConstructorExperience } from 'selectors/shared/constructorExperience'

const Header: FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)
  const [mobileHeaderConfig, setMobileHeaderConfig] = useState<MobileHeaderConfig>({
    mobileTopHeader: 'mainTopHeader',
    mobileMenuContent: 'null',
    isMobileMenuOpen: false,
  })

  const isConstructorExperience = useSelector(getSharedIsConstructorExperience)
  const transformLinksForConstructor = (navigationLinks: NavigationLinksArray) => {
    return constructorAbTestInPrintsLinks({
      navigationLinks,
      isConstructor: isConstructorExperience,
    })
  }

  // necessary only while having AB Test with Algolia and Constructor
  const transformedNavigationLinks = transformNavLinks({
    navigationLinks: NavigationLinks,
    transformFunction: transformLinksForConstructor,
  })

  return (
    <HeaderProvider
      value={{
        selectedCategory,
        setSelectedCategory,
        mobileHeaderConfig,
        setMobileHeaderConfig,
        navigationLinks: transformedNavigationLinks,
      }}
    >
      <MobileHeader />
      <DesktopHeader />
      <div className={styles.cartUrgencyBox}>
        <CartUrgencyBar />
      </div>
    </HeaderProvider>
  )
}

export default Header
